export default __webpack_public_path__ + "static/media/logo-text.5862267e.svg";